/*

  404 Page Layout

*/


import React from "react"

import Layout from "../components/layout/layout.js"
import FileNotFoundContent from "../components/404-content/404-content"

const FourOFourPage = () => (
  <Layout>
    <FileNotFoundContent />
  </Layout>
)


export default FourOFourPage
